import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, timer } from 'rxjs';
import { map } from 'rxjs/operators';

// export interface ErrorData{
//   errorStatus : string,
//   browserUrl : string,
//   apiUrl : string,
//   timestamp : string,
//   token : string
// }

@Component({
  selector: 'icullen-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit, OnDestroy {
  errorStatus = '';
  errorData: any;

  qrdata = '';
  elementType: 'img';
  level: 'M';
  scale: number;
  width: number;

  refreshSubscription: Subscription;

  QrCodeIsShow = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    if (
      this.router.getCurrentNavigation() &&
      this.router.getCurrentNavigation().extras
    ) {
      this.errorData = this.router.getCurrentNavigation().extras?.state;
    }

    this.errorStatus = this.router.url.replace('/', '');

    if (this.errorData) {
      this.elementType = 'img';
      this.level = 'M';
      this.scale = 1;
      this.width = 200;
      this.qrdata =
        this.errorData.errorStatus +
        ' | ' +
        this.errorData.browserUrl +
        ' | ' +
        this.errorData.apiUrl +
        ' | ' +
        this.errorData.timestamp +
        ' | ' +
        this.errorData.responseTime +
        ' | ' +
        this.errorData.UserID +
        ' | ' +
        this.errorData.transactionId;
    }
  }

  ngOnInit() {
    // this.route.data.subscribe(routeData => {
    //   if (routeData.errorStatus) {
    //     this.errorStatus = routeData.errorStatus;
    //     //console.log(this.errorStatus);
    //   }
    // });
    //refresh every 60 seconds
    // this.refreshSubscription = timer(15000, 30000)
    //   .pipe(
    //     map(() => {
    //       if (!this.is404()) {
    //         console.log('Automatic refresh of page');
    //         if (navigator.onLine) {
    //           this.refreshPage();
    //         }
    //       }
    //     })
    //   )
    //   .subscribe();
  }

  showQrCodeOnClick() {
    this.QrCodeIsShow = true;
  }

  is404(): boolean {
    return this.errorStatus === '404';
  }

  is401(): boolean {
    return this.errorStatus === '401';
  }

  goBack() {
    this.location.back();
  }

  refreshPage() {
    window.location.reload();
  }

  getMailToText(): string {
    if (this.errorData) {
      return (
        'mailto:helpdesk@cullen-international.com?subject=Cullen Website - Unexpected error occurred&body=' +
        this.errorData.errorStatus +
        ' | ' +
        this.errorData.browserUrl +
        ' | ' +
        this.errorData.apiUrl +
        ' | ' +
        this.errorData.timestamp +
        ' | ' +
        this.errorData.token +
        ' | ' +
        this.errorData.responseTime +
        ' | ' +
        this.errorData.UserID +
        ' | ' +
        this.errorData.transactionId
      );
    }
  }

  ngOnDestroy(): void {
    //this.refreshSubscription.unsubscribe();
  }
}
